/** @format */

import request from '@edgeguideab/client-request';
import config from 'config.json';
import loginRedirect from './loginRedirect';
import urls from 'utils/urls';
import history from 'utils/history';

export default function fetchUsers(originalRoute) {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch({ type: 'SESSION_FETCH_USERS_START' });
    let response;
    const requestUrl = `${config.apiServer}/sessions/fetchUsers`;
    try {
      response = await request.get(requestUrl);
    } catch (errorResponse) {
      if (errorResponse.status === 404) {
        const url = urls.noUser;
        return history.push(url);
      }
      return dispatch({
        type: 'SESSION_FETCH_USERS_FAILED',
        payload: {
          msg: errorResponse.body.msg || 'errors.maintenance'
        }
      });
    }

    window.localStorage.setItem('csrfToken', response.body.csrfToken);
    dispatch({
      type: 'SESSION_FETCH_USERS_DONE',
      payload: response.body
    });

    const hasStartPage = state.global.get('ewmFeatures').includes('startPage');
    loginRedirect({
      hasStartPageAccess: response.body.user?.acl.startPage.read.length > 0,
      hasStartPage,
      path: originalRoute
    });
  };
}
